import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

const { spacers, color, border } = baseVariables;
const spacer01 = spacers?.spacers?.[1] ?? '0.25rem';
const spacer03 = spacers?.spacer ?? '1rem';
const colorNeutral30 = color?.neutral30;
const colorBase10 = color?.base10;
const colorBase20 = color?.base20;
const colorNeutral40 = color?.neutral40;
export const logoHoverColor = colorBase10;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: ${spacer03};
  padding: 0.9375rem;
  border: ${border?.borderWidth02 ?? '0.063rem'} ${border?.borderStyleDefault ?? 'solid'} transparent;
  border-radius: ${border?.borderRadiusDefault ?? '0.875rem'};
  background: linear-gradient(to bottom, ${colorBase20}, ${colorBase20}) padding-box,
    linear-gradient(to bottom, ${colorNeutral30}, transparent) border-box;

  .brand-ribbon-category-label {
    text-align: center;
    margin-block-end: 0;
    padding-block-end: ${spacer01};
    color: ${colorBase10};
    text-transform: capitalize;
  }

  .brand-ribbon-category-description {
    text-align: center;
    padding-block-end: ${spacer01};
    color: ${colorNeutral40};
  }

  .brand-ribbon-category-list {
    list-style-type: none;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: ${spacer03};
  }

  .brand-ribbon-category-list-item {
    svg {
      max-width: 100%;
      max-height: 100%;
      opacity: 1;
    }
  }
`;
